import React from 'react';

const Lock = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" },
    className
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.00024 11.5669C8.60039 11.5669 9.08691 11.0804 9.08691 10.4802C9.08691 9.88007 8.60039 9.39355 8.00024 9.39355C7.40009 9.39355 6.91357 9.88007 6.91357 10.4802C6.91357 11.0804 7.40009 11.5669 8.00024 11.5669Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.58691 10.4802C8.58691 10.8042 8.32425 11.0669 8.00024 11.0669C7.67623 11.0669 7.41357 10.8042 7.41357 10.4802C7.41357 10.1562 7.67623 9.89355 8.00024 9.89355C8.32425 9.89355 8.58691 10.1562 8.58691 10.4802Z",
      stroke: "white",
      strokeOpacity: "0.3"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.1868 6.3535V5.52016C12.1868 3.72016 11.7535 1.3335 8.00016 1.3335C4.24683 1.3335 3.8135 3.72016 3.8135 5.52016V6.3535C1.94683 6.58683 1.3335 7.5335 1.3335 9.86016V11.1002C1.3335 13.8335 2.16683 14.6668 4.90016 14.6668H11.1002C13.8335 14.6668 14.6668 13.8335 14.6668 11.1002V9.86016C14.6668 7.5335 14.0535 6.58683 12.1868 6.3535ZM8.00016 12.4935C6.88683 12.4935 5.98683 11.5868 5.98683 10.4802C5.98683 9.36683 6.8935 8.46683 8.00016 8.46683C9.10683 8.46683 10.0135 9.3735 10.0135 10.4802C10.0135 11.5935 9.1135 12.4935 8.00016 12.4935ZM4.90016 6.2935C4.84683 6.2935 4.80016 6.2935 4.74683 6.2935V5.52016C4.74683 3.56683 5.30016 2.26683 8.00016 2.26683C10.7002 2.26683 11.2535 3.56683 11.2535 5.52016V6.30016C11.2002 6.30016 11.1535 6.30016 11.1002 6.30016H4.90016V6.2935Z",
      fill: "white",
      fillOpacity: "0.6"
    }
  )
);
Lock.displayName = "Icons.Lock";

export { Lock };
//# sourceMappingURL=Lock.js.map
